import {captureException} from '@sentry/react'
import axios, {parseAxiosPromise} from '@/axiosInstance.ts'
import {AvailablePriTxtMonths, PriTxtExportRequest} from '@/features/accesses/activity-report/types'

/* GET the periods ('MM-YYYY') for which a DSP Flux export can be generated. Server-sorted
   most-recent-first; empty ⇒ no month is exportable. */
export const httpGetPriTxtAvailableMonths = () =>
    parseAxiosPromise({
        axiosPromise: axios.get('/accesses/pri-txt/available-months'),
        responseShape: AvailablePriTxtMonths,
        onZodError: captureException
    })

/* POST generate the export → binary ZIP (PRI1 + PRI2 tracks). Returns the raw axios response so the
   caller can read both the blob body and the Content-Disposition header; not parsed via zod (binary). */
export const httpExportPriTxtByMonth = (payload: PriTxtExportRequest) =>
    axios.post<Blob>('/accesses/export-pri-txt-by-month', payload, {responseType: 'blob'})
